<template>
    <v-data-table
        :loading="loading"
        :items="items"
        :headers="headers"
        :page.sync="page"
        :server-items-length="totalDocuments"
        :items-per-page.sync="itemsPerPage"
        @update:options="updateOptions"
        :footer-props="{
            'items-per-page-options': [25, 50, 100]
        }"
    >
        <template v-slot:item.id="{ item }">
            <v-chip color="grey">{{ item.id }}</v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
            {{ dayjs(Number(item.createdAt)).format('DD/MM/YYYY HH:mm:ss') }}
        </template>
        <template v-slot:item.isValidOrderId="{ item }">
            <v-icon left :color="item.isValidOrderId ? 'green' : 'red'">
                {{ item.isValidOrderId ? 'mdi-check-circle' : 'mdi-alert-circle' }}
            </v-icon>
            <span>{{ item.isValidOrderId ? 'ID de Orden Válido' : 'ID de Orden Inválido' }}</span>
        </template>
        <template v-slot:item.hasOrderIdBeenUsed="{ item }">
            <v-icon left :color="item.hasOrderIdBeenUsed ? 'red' : 'green'">
                {{ item.hasOrderIdBeenUsed ? 'mdi-alert-circle' : 'mdi-check-circle' }}
            </v-icon>
            <span>{{ item.hasOrderIdBeenUsed ? 'ID de Orden Duplicado' : 'ID de Orden Único' }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-btn color="info" icon @click="$emit('view-response', item)">
                <v-icon>mdi-information</v-icon>
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
    import dayjs from 'dayjs';
    import SurveyResponseProvider from '../../../providers/SurveyResponseProvider'

    export default {
        name: "SurveyResponsesTable",
        props: {
            needUpdate: {
                type: Boolean,
                required: true
            },
            filters: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            dayjs,
            page: 1,
            headers: [
                { text: '# ID', value: 'id', sortable: false },
                { text: 'Fecha de creación', value: 'createdAt', sortable: false },
                { text: 'Orden', value: 'order', sortable: false },
                { text: '¿Es una orden valida?', value: 'isValidOrderId', sortable: false },
                { text: '¿Ya se hizo una encuesta con la misma orden?', value: 'hasOrderIdBeenUsed', sortable: false },
                { text: 'Encuesta', value: 'survey.name', sortable: false },
                { text: 'Acciones', value: 'actions', sortable: false }
            ],
            items: [],
            loading: false,
            totalDocuments: 0,
            itemsPerPage: 25
        }),
        mounted() {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                this.loading = true;
                try {
                    const filters = {
                        startDate: this.filters.startDate,
                        endDate: this.filters.endDate,
                        survey: this.filters.survey && this.filters.survey.length ? JSON.stringify(this.filters.survey) : null,
                        isValidOrderId: this.filters.isValidOrderId,
                        hasOrderIdBeenUsed: this.filters.hasOrderIdBeenUsed
                    }
                    const {data: {paginateSurveyResponse}} = await SurveyResponseProvider.paginateSurveyResponse(this.page, this.itemsPerPage, filters);
                    this.totalDocuments = paginateSurveyResponse.totalItems;
                    this.items = paginateSurveyResponse.items;
                } catch (error) {
                    console.error("Error fetching survey responses:", error);
                } finally {
                    this.loading = false;
                    this.$emit('update:needUpdate', false);
                }
            },
            updateOptions(){
                setTimeout(this.fetchData);
            }
        },
        watch: {
            needUpdate: {
                handler(newValue) {
                    if (newValue) {
                        this.fetchData();
                    }
                },
                immediate: true
            }
        }
    }
</script>